import { NzButtonModule } from 'ng-zorro-antd';
import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TextMaskModule } from 'angular2-text-mask';
import { PhxButtonModule, PhxIconModule } from 'phx-core';

import { HardwareUnitComponent } from './hardware-unit.component';
import { FeatureUpgradeComponent } from './feature-upgrade.component';
import { DevicesUpgradeComponent } from './devices-upsell.component';
import { TrialActivatedModalComponent } from './trial-activated-modal.component';
import { GeneralUpgradeModalComponent } from './general-upgrade-modal.component';
import { GeneralUpgradeComponent } from './general-upgrade.component';
import { UpsellEntryPopupComponent } from './upsell-entry-popup.component';
import { ThankyoudModalComponent } from './thankyou-modal.component';
import { UpgradeTopBarComponent } from './upsell-topbar.component';
import { VideoComponent } from './upsell-video-player.component';

import { FeatureUpgradeService } from './upgrade.service';
import { TimeZoneFormatService } from '@app/admin/fleet-card/shared/billing-tz.service';
import { FleetCardsFeatureFlagService } from '@app/services/feature-flags/fleet-cards';
import { GeneralUpsellComponent } from './general-upsell/general-upsell.component';

const providers: any = [FeatureUpgradeService, FleetCardsFeatureFlagService, TimeZoneFormatService];

const COMPONENTS = [
  HardwareUnitComponent,
  DevicesUpgradeComponent,
  FeatureUpgradeComponent,
  TrialActivatedModalComponent,
  GeneralUpgradeModalComponent,
  GeneralUpgradeComponent,
  UpsellEntryPopupComponent,
  ThankyoudModalComponent,
  UpgradeTopBarComponent,
  VideoComponent,
  GeneralUpsellComponent,
];

@NgModule({
  imports: [
    NgCommonModule,
    RouterModule,
    TextMaskModule,
    NzButtonModule,
    PhxIconModule,
    PhxButtonModule,
  ],
  declarations: COMPONENTS,
  exports: [COMPONENTS],
  providers,
})
export class UpsellModule {}
